import React from 'react';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import { useContext } from 'react';
import { UiContext } from 'shared/lib/contexts/uiContext';
import CellContainer from 'shared/lib/extendedComponents/grids/components/cellContainer';
import { borderRadiusValues } from 'shared/lib/utils/uiConstants';
import { GridRowContext } from 'shared/lib/extendedComponents/grids/components/gridRowContainer';
import { makeTransition } from 'shared/lib/utils/utils';
import LimitedTypography from 'shared/lib/components/text/limitedTypography';
import IconFile from 'shared/icons/iconFile';

const clamp = 2;

export default function DesktopTableNameCell({
  name,
  lastChangeAuthor,
  onClick,
}: {
  name: string;
  lastChangeAuthor: string | null;
  onClick?: () => void;
}) {
  const theme = useTheme();
  const {
    spacings: { sp, icons },
  } = useContext(UiContext);
  const { isHover } = useContext(GridRowContext);

  const color = isHover
    ? theme.palette.primary.main
    : theme.palette.text.primary;

  return (
    <CellContainer onClick={onClick} sx={{ pl: '0 !important' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: sp.s50,
        }}
      >
        <Paper
          elevation={4}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'center',
            width: icons['48x48'].w,
            height: icons['48x48'].h,
            minWidth: icons['48x48'].w,
            minHeight: icons['48x48'].h,
            borderRadius: borderRadiusValues.XSmall,
          }}
        >
          <IconFile sizeKey="48x48"></IconFile>
        </Paper>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: sp.s20,
            width: 1,
          }}
        >
          <LimitedTypography
            variant="f20b"
            clamp={clamp}
            sx={{
              color,
              transition: makeTransition(['color']),
            }}
          >
            {name}
          </LimitedTypography>
          {lastChangeAuthor && (
            <Typography
              variant="f14"
              color="text.secondary"
            >{`Редактор: ${lastChangeAuthor}`}</Typography>
          )}
        </Box>
      </Box>
    </CellContainer>
  );
}
